var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ScrollContainer/index.tsx";
import React, { memo, useEffect, useRef, useState } from 'react';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { connect } from 'react-redux';
import { Stack } from '@adc/parallax-component-library';
import { scrolledTopOrBottom } from 'Utilities/newyu';
import { store } from 'Utilities/store';
const mapStateToProps = ({
  scrollPage
}) => {
  return {
    scrollPage
  };
};
const connector = connect(mapStateToProps);
const _worklet_1319775703612_init_data = {
  code: "function indexTsx1(e){const{scrollRef,scrolledTopOrBottom,store}=this.__closure;if(!scrollRef.current){return;}const scrollBottomedOut=scrolledTopOrBottom(scrollRef.current).bottom;store.dispatch({type:'SCROLL_STATUS',status:{scrollValue:e.contentOffset.y,bottomedOut:scrollBottomedOut}});}",
  location: "/opt/atlassian/pipelines/agent/build/src/components/utility/ScrollContainer/index.tsx",
  sourceMap: "{\"version\":3,\"names\":[\"indexTsx1\",\"e\",\"scrollRef\",\"scrolledTopOrBottom\",\"store\",\"__closure\",\"current\",\"scrollBottomedOut\",\"bottom\",\"dispatch\",\"type\",\"status\",\"scrollValue\",\"contentOffset\",\"y\",\"bottomedOut\"],\"sources\":[\"/opt/atlassian/pipelines/agent/build/src/components/utility/ScrollContainer/index.tsx\"],\"mappings\":\"AAwEe,QAAC,CAAAA,SAAKA,CAAAC,CAAA,QAAAC,SAAA,CAAAC,mBAAA,CAAAC,KAAA,OAAAC,SAAA,CACf,GAAI,CAACH,SAAS,CAACI,OAAO,CAAE,CACtB,OACF,CAEA,KAAM,CAAAC,iBAAiB,CAAGJ,mBAAmB,CAACD,SAAS,CAACI,OAAO,CAAC,CAACE,MAAM,CAEvEJ,KAAK,CAACK,QAAQ,CAAC,CACbC,IAAI,CAAE,eAAe,CACrBC,MAAM,CAAE,CAAEC,WAAW,CAAEX,CAAC,CAACY,aAAa,CAACC,CAAC,CAAEC,WAAW,CAAER,iBAAkB,CAC3E,CAAC,CAAC,CACJ\",\"ignoreList\":[]}"
};
const ScrollContainer = ({
  children,
  scrollPage
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const scrollRef = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const childrenRef = useRef(null);
  const [isScrollActive, setIsScrollActive] = useState(false);
  useEffect(() => {
    store.dispatch({
      type: 'SCROLL_ACTIVE',
      isActive: isScrollActive
    });
    if (!isScrollActive) {
      scrollRef.current?.scrollTo({
        top: 0
      });
    }
  }, [isScrollActive]);
  useEffect(() => {
    if (childrenRef.current && scrollRef.current) {
      const mainHeight = scrollPage.mainSize ? scrollPage.mainSize : window.innerHeight;
      if (childrenRef.current.clientHeight > mainHeight - scrollPage.footerSize - 100) {
        setIsScrollActive(true);
      }
      let lastChildPaddingBottom = 0;

      // Get last child element padding bottom size.
      if (childrenRef.current.lastChild?.style.paddingBottom) {
        const paddingBottom = childrenRef.current.lastChild.style.paddingBottom;
        lastChildPaddingBottom = Number(paddingBottom.replace('px', '').trim());
      }

      // Verify if the child element has resized, if so, enable or disable the scroll.
      const resizeObserver = new ResizeObserver(() => {
        if (childrenRef.current) {
          const hasIncreasedChildElementSize = childrenRef.current.clientHeight > mainHeight - (scrollPage.footerSize - lastChildPaddingBottom) - 100;
          setIsScrollActive(hasIncreasedChildElementSize);
        }
      });
      resizeObserver.observe(childrenRef.current);
      return () => resizeObserver.disconnect();
    }
  }, [scrollPage.footerSize, scrollPage.mainSize]);
  const scrollHandler = useAnimatedScrollHandler({
    onScroll: function indexTsx1Factory({
      _worklet_1319775703612_init_data,
      scrollRef,
      scrolledTopOrBottom,
      store
    }) {
      const _e = [new global.Error(), -4, -27];
      const indexTsx1 = function (e) {
        if (!scrollRef.current) {
          return;
        }
        const scrollBottomedOut = scrolledTopOrBottom(scrollRef.current).bottom;
        store.dispatch({
          type: 'SCROLL_STATUS',
          status: {
            scrollValue: e.contentOffset.y,
            bottomedOut: scrollBottomedOut
          }
        });
      };
      indexTsx1.__closure = {
        scrollRef,
        scrolledTopOrBottom,
        store
      };
      indexTsx1.__workletHash = 1319775703612;
      indexTsx1.__pluginVersion = "0.5.2";
      indexTsx1.__initData = _worklet_1319775703612_init_data;
      indexTsx1.__stackDetails = _e;
      return indexTsx1;
    }({
      _worklet_1319775703612_init_data,
      scrollRef,
      scrolledTopOrBottom,
      store
    })
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Animated.ScrollView, {
    style: {
      marginTop: scrollPage.actionBarSize
    },
    ref: scrollRef,
    onScroll: scrollHandler,
    scrollEventThrottle: 16,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    ref: childrenRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 9
    }
  }, children)));
};
const ConnectedScrollContainer = connector(/*#__PURE__*/memo(ScrollContainer));
export { ConnectedScrollContainer as ScrollContainer };